import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect } from 'react';
import webWorker from './webWorker';

const functionToURL = fn => {
  const blob = new Blob([`(${fn.toString()})()`], { type: 'text/javascript' });

  return URL.createObjectURL(blob);
};

const WarmVDPCache = () => {
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    if (window.Worker) {
      try {
        trackEvent('SRP Prefetch Worker Attempted');
        const url = functionToURL(webWorker);
        const worker = new Worker(url);

        worker.onerror = e => {
          console.log('Web Worker failed:', e.message);
        };

        worker.postMessage({
          CVNA_APP_ASSETS_CDN: process.env.CVNA_APP_ASSETS_CDN
        });

        worker.addEventListener('message', ({ data }) => {
          if (data === 'success') {
            trackEvent('SRP Prefetch Worker Succeeded');
          }
        });
      } catch (e) {
        console.log('Web Worker instantiation failed: ', e);
      }
    }
  }, []);

  return null;
};

export default WarmVDPCache;
